import * as React from 'react';
import { SWRConfig } from 'swr';
import AddToCartOverlayProvider from 'context/add-to-cart-overlay';
import DistributorSelectorProvider from 'context/distributor-selector';

export const FrontasticProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <SWRConfig>
      <DistributorSelectorProvider>
        <AddToCartOverlayProvider>{children}</AddToCartOverlayProvider>
      </DistributorSelectorProvider>
    </SWRConfig>
  );
};
